module.exports = __webpack_public_path__ + "img/CNN-COVER.15b61d79.png";